import { guard } from 'utils/middleware'
import { registerModule } from '@/router'
import stockCompare from './stores'

const name = 'stockcompare'

export const router = {
  path: `/${name}`,
  component: { template: '<router-view/>' },
  beforeEnter: (...router) => {
    guard(name, [router, { logout: true }])
    registerModule(name, stockCompare)
  },
  children: [
    {
      path: '',
      meta: { title: () => 'Stock Compare' },
      name,
      component: () =>
        import('modules/stockcompare/pages/StockCompareDashboard')
    },
    {
      path: 'sellers',
      meta: { title: () => 'Stock Compare Sellers' },
      name: `${name}-sellers`,
      component: () => import('modules/stockcompare/pages/StockCompareSellers')
    }
  ]
}
